import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/settings/organisation/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/settings/organisation/general" });
  },
});
